jQuery(document).ready(function ($) {
  $("li.reviewTab span").on("click", function () {
    var reviewToMove = $("div.ezrv-widget-container");
    var ratingBox = $("#shopify-product-reviews");
    reviewToMove.insertAfter(ratingBox);
  });


$("#shop-slider-two").owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 5000,
    nav: true,
    dots: false,
    autoplaySpeed: 500,
    navText: ["<i class='feather-arrow-left'></i>", "<i class='feather-arrow-right'></i>"],
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      640: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1200: {
        items: 4,
      }
    }
  });

  $("#shop-slider-three").owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 5000,
    nav: true,
    dots: false,
    autoplaySpeed: 500,
    navText: ["<i class='feather-arrow-left'></i>", "<i class='feather-arrow-right'></i>"],
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      640: {
        items: 2,
      },
      991: {
        items: 3,
      },
      1200: {
        items: 4,
      }
    }
  });



  
});
